import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from "@angular/core";
import { HalResourceNotificationService } from "core-app/features/hal/services/hal-resource-notification.service";
import {
  WorkPackageNotificationService,
} from "core-app/features/work-packages/services/notifications/work-package-notification.service";
import { DragAndDropService } from "core-app/shared/helpers/drag-and-drop/drag-and-drop.service";
import { CausedUpdatesService } from "core-app/features/boards/board/caused-updates/caused-updates.service";
import {
  WorkPackageListViewComponent,
} from "core-app/features/work-packages/routing/wp-list-view/wp-list-view.component";
import {
  WorkPackageTableConfigurationObject,
} from "core-app/features/work-packages/components/wp-table/wp-table-configuration";
import { InviteUserButtonComponent } from "core-app/features/invite-user-modal/button/invite-user-button.component";
import { WorkPackagesTableComponent } from 'core-app/features/work-packages/components/wp-table/wp-table.component';
import {
  WorkPackageViewSortByService,
} from 'core-app/features/work-packages/routing/wp-view-base/view-services/wp-view-sort-by.service';
import { InjectField } from 'core-app/shared/helpers/angular/inject-field.decorator';

@Component({
  selector: 'wp-list-view-iframe',
  templateUrl: './wp-list-view-iframe.component.html',
  styleUrls: ['../../../../../../../../frontend/src/app/features/work-packages/routing/wp-list-view/wp-list-view.component.sass'],
  host: { class: 'op-wp-list-view work-packages-split-view--tabletimeline-side' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: HalResourceNotificationService, useClass: WorkPackageNotificationService },
    DragAndDropService,
    CausedUpdatesService,
  ],
})
export class WorkPackageListViewIframeComponent extends WorkPackageListViewComponent {
  @ViewChild(WorkPackagesTableComponent) wpTable:WorkPackagesTableComponent;

  @InjectField() wpTableSortBy:WorkPackageViewSortByService;

  readonly wpTableConfiguration:WorkPackageTableConfigurationObject = {
    dragAndDropEnabled: true,
    inlineCreateEnabled: false,
    compactTableStyle: false,
    actionsColumnEnabled: false,
    contextMenuEnabled: false,
  };

  ngOnInit() {
    super.ngOnInit();

    document.addEventListener('click', (event:MouseEvent) => {
      let element = event.target as HTMLElement;
      let inviteButton = element.closest('op-invite-user-button');
      if (inviteButton) {
        // @ts-ignore
        let inviteButtonComponent:InviteUserButtonComponent = ng.getComponent(inviteButton);
        event.stopPropagation();
        inviteButtonComponent.autocompleter.closeSelect();
        this.openInviteUser(inviteButtonComponent.projectId);
      }
    }, true);

    this
      .querySpace
      .tableRendered
      .values$()
      .subscribe(() => {
        jQuery(".-editable", this.wpTable.tbody).removeClass('-editable')
      });
  }

  manualSortEnabled():boolean {
    return this.wpTableSortBy.isManualSortingMode
  }

  handleWorkPackageCardClicked(event:{ workPackageId:string; double:boolean }) {
    if (this.deviceService.isMobile) {
      this.openExternal(event.workPackageId);
    } else {
      this.handleWorkPackageClicked(event);
    }
  }

  handleWorkPackageClicked(event:{ workPackageId:string; double:boolean }) {
    if (event.double) {
      this.openExternal(event.workPackageId);
    }
  }

  openStateLink(event:{ workPackageId:string; requestedState:"show"|"split" }) {
    this.openExternal(event.workPackageId);
  }

  openExternal(workPackageId:string) {
    window.parent.postMessage({ action: 'WorkPackageOpen', wp_id: workPackageId }, '*');
  }

  openInviteUser(projectId:string|null) {
    window.parent.postMessage({ action: 'InviteUser', project_id: projectId }, '*');
  }
}
